import { useApi } from '@omnipresentgroup/api';
import type { UpdateContractorContractRequest } from '@omnipresentgroup/types';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { API_BASE, API_PATH } from '../constants';
import { transformUpdateContractorContractRequestToAPI } from '../mappers';
import { getContractorKey } from './useContractor';

export const useContractorContractMutation = ({
  contractorId,
  contractId,
  userId,
}: {
  contractorId: string;
  contractId: string;
  userId?: string;
}) => {
  const { PUT } = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: UpdateContractorContractRequest) => {
      return PUT({
        path: `${API_BASE}/${API_PATH}/${contractorId}/contracts/${contractId}`,
        body: transformUpdateContractorContractRequestToAPI(payload),
      });
    },
    onSuccess: () => {
      // refresh the list of contractors query
      queryClient.invalidateQueries({
        queryKey: [API_PATH],
        exact: true,
      });
      // refresh the specific contractor queries
      queryClient.invalidateQueries({
        queryKey: getContractorKey(userId || contractorId),
      });
    },
  });
};
